import { api } from 'utility';
import db from 'utility/DexieDb';
import {
    getStatesUrl,
    getCitiesUrl,

} from 'URLs';
const CITY_URL = (stateId, stateName) => `${getCitiesUrl()}?stateId=${encodeURIComponent(stateId)}&state=${encodeURIComponent(stateName)}`;

/**
 * getStates: از کش می‌خواند؛ در صورت نبودن -> fetch و سپس ذخیره در کش
 */
export async function getStates({ forceRefresh = false } = {}) {
    if (!forceRefresh) {
        try {
            const cached = await db.states.toArray();
            if (cached && cached.length) {
                return cached;
            }
        } catch (err) { }
    }

    // fetch from server
    const res = await api.get(getStatesUrl());
    // فرض می‌کنیم پاسخ آرایه‌ای از { id, name }
    const data = Array.isArray(res.data) ? res.data : (res.data?.result || []);
    if (Array.isArray(data) && data.length) {
        // bulkPut تا درصورت وجود، مقدار جایگزین شود
        try {
            await db.states.bulkPut(data);
        } catch (err) { }
    }
    return data;
}

/**
 * getCities: ابتدا دنبال شهرها با stateId در کش می‌گردد. درصورت نبود -> شبکه و سپس ذخیره در کش.
 * stateId: number|string
 * stateName: string (برای endpoint)
 */
export async function getCities(stateId, stateName, { forceRefresh = false } = {}) {
    if (!stateId) return [];

    if (!forceRefresh) {
        try {
            const cached = await db.cities.where('stateId').equals(stateId).toArray();
            if (cached && cached.length) {
                return cached;
            }
        } catch (err) { }
    }

    // fetch from server
    const res = await api.get(CITY_URL(stateId, stateName || ''));
    const data = Array.isArray(res.data) ? res.data : (res.data?.result || []);
    if (Array.isArray(data) && data.length) {
        const normalized = data.map((c) => ({
            cityId: c.id,
            stateId: stateId,
            name: c.name,
            // می‌تونیم هر فیلد دیگه‌ای که نیاز هست اضافه کنیم
        }));
        try {
            await db.cities.where('stateId').equals(stateId).delete();
            await db.cities.bulkPut(normalized);
        } catch (err) { }
        return normalized;
    }
    return [];
}